export default __webpack_public_path__ + "static/media/header-logo.7288d36a.svg";